export default __webpack_public_path__ + "static/video-7-4059ba6af3e417238244a81436817b0f.png";